import { Component, Input,  OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { SharedDataService, SuppliersService } from '../../all-services';
import { Supplier, SupplierStatut } from '../../all-models';

export enum SupplierStatutBadgeSize {
  SMALL = 'small',
  NORMAL = 'normal',
  LARGE = 'large'
}

@Component({
  selector: 'supplier-statut-badge',
  templateUrl: './supplier-statut-badge.component.html',
  styleUrls: ['./supplier-statut-badge.component.scss']
})
export class SupplierStatutBadgeComponent implements OnInit, OnChanges {

  @Input() supplier?: Supplier;
  @Input() supplierStatutId?: number;
  @Input() size?: SupplierStatutBadgeSize = SupplierStatutBadgeSize.NORMAL;

  constructor(
    private suppliersSvc: SuppliersService,
    public sharedDataSvc: SharedDataService) { }
  ngOnChanges(changes: SimpleChanges): void {
    // if ((changes['supplier'] && this.supplier)
    //     ||(changes['supplierStatutId'] && this.supplierStatutId)){
    //   this.reloadSupplierStatut();
    // }
  }

  ngOnInit(): void {
    // this.sharedDataSvc.listsLoaded.subscribe(():void=>{
    //   this.reloadSupplierStatut();
    // });
    // this.reloadSupplierStatut();        
  }

  public get supplierStatut(): SupplierStatut | undefined{
    if (!this.sharedDataSvc.supplierStatuts) return undefined;
    if (this.supplier) {
        return this.sharedDataSvc.supplierStatuts.find(statut=>statut.Id==this.supplier.StatutId);
    } else if (this.supplierStatutId) {
        return this.sharedDataSvc.supplierStatuts.find(statut=>statut.Id==this.supplierStatutId);      
    }
    return undefined;
  }
  
  // reloadSupplierStatut():void{
  //   if (this.supplier) {
  //     this.supplierStatut = this.suppliersSvc.supplierStatut(this.supplier);
  //   } else if (this.supplierStatutId) {
  //     this.supplierStatut = this.sharedDataSvc.supplierStatuts.find(statut=>statut.Id==this.supplierStatutId)
  //   } else {
  //     return null;
  //   }
  // }

  get statutLibCod(): string {
    if (this.supplierStatut) {
      if (this.sharedDataSvc.portalType == 'EXTRANET') {
        return this.supplierStatut.LblCodExtranet;
      } else {
        return this.supplierStatut.LblCod;
      }
    } else {
      return '';
    }
  }
  get statutCod(): string {
    if (this.supplierStatut) {
     return this.supplierStatut.Cod;
    } else {
      return '';
    }
  }
  get statutId(): number {
    return this.supplierStatut?.Id || 0;
  }


  get badgeNgClass(): string {
    if (!this.supplierStatut) return '';
    let sizeClass = '';
    switch (this.size) {
      case SupplierStatutBadgeSize.SMALL:
        sizeClass = 'small';
        break;
      case SupplierStatutBadgeSize.NORMAL:
        sizeClass = 'normal';
        break;
      case SupplierStatutBadgeSize.LARGE:
        sizeClass = 'large';
        break;
      default:
        sizeClass = 'normal';
    }
    return 'badge badge-' + this.suppliersSvc.SupplierStatutCss(this.supplierStatut.Id) + ' ' + sizeClass;
  }

}
